<template>
  <div class="list-approval-config-page">
    <KTCodePreview v-bind:title="'Danh sách cấu hình duyệt chi'">
      <template v-slot:toolbar>
        <div
          class="row"
          v-if="checkPermission('APPROVAL_CONFIG_INSERT')"
        >
          <router-link to="/approval-configs/info">
            <b-button
              variant="primary"
              size="sm"
              class="create-button font-weight-bolder"
            >
              <i class="flaticon2-add-1 add-icon"></i>Thêm mới
            </b-button>
          </router-link>
        </div>
      </template>

      <template v-slot:preview>
        <approval-config-filter
          :type-options="listType"
          :status-options="listStatus"
          :initial-filter="filterData"
          @filter="handleFilter"
        />

        <approval-config-table
          :items="listItem"
          :loading="onLoading"
          :has-update-permission="checkPermission('APPROVAL_CONFIG_UPDATE')"
          :has-delete-permission="checkPermission('APPROVAL_CONFIG_DELETE')"
          @view="editItem"
          @edit="editItem"
          @delete="showDeleteAlert"
        />

        <approval-config-pagination
          :total-items="totalItems"
          :total-pages="totalPages"
          :current-page="page"
          @page-change="handlePageChange"
        />
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { cloneDeep, convertPrice } from '@/utils/common';
import { APPROVAL_TYPE } from '@/utils/constants';
import { checkPermission } from '@/utils/saveDataToLocal';
import KTCodePreview from '@/view/content/CodePreview.vue';
import Swal from 'sweetalert2';
import ApprovalConfigService from '../services/ApprovalConfigService';

// Import components
import {
  ApprovalConfigFilter,
  ApprovalConfigPagination,
  ApprovalConfigTable,
} from './components';

export default {
  components: {
    KTCodePreview,
    ApprovalConfigFilter,
    ApprovalConfigTable,
    ApprovalConfigPagination,
  },
  data() {
    return {
      onLoading: false,

      listItem: [],
      totalPages: 1,
      totalItems: 0,
      page: 1,

      filterData: {
        name: '',
        type: null,
        status: null,
      },

      listStatus: [
        {
          id: null,
          name: 'Tất cả trạng thái',
        },
        {
          id: 1,
          name: 'Hoạt động',
        },
        {
          id: 0,
          name: 'Đã khóa',
        },
      ],
      listType: APPROVAL_TYPE,
    };
  },
  methods: {
    convertPrice,
    checkPermission,

    /**
     * Fetch data from API
     */
    fetchData: async function () {
      this.onLoading = true;
      this.page = this.$route.query.page || 1;

      const params = {
        page: this.page,
        limit: 10,
        name: this.filterData.name ? this.filterData.name.trim() : '',
        isActive: this.filterData.status,
        approvalType: this.filterData.type,
      };

      try {
        const data = await ApprovalConfigService.fetchApprovalConfigs(params);
        this.totalPages = data.totalPages;
        this.totalItems = data.totalItems;
        this.listItem = data.items;
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.onLoading = false;
      }
    },

    /**
     * Handle filter change
     */
    handleFilter(filterData) {
      this.filterData = { ...filterData };
      this.$route.query.page = 1;
      this.$router.push({
        name: 'list-approval-config',
      });
      this.fetchData();
    },

    /**
     * Handle page change
     */
    handlePageChange(page) {
      this.page = page;
      this.fetchData();
    },

    /**
     * Navigate to edit page
     */
    editItem: function (item) {
      this.$router.push({
        name: 'info-approval-config',
        query: { id: item.id },
      });
    },

    /**
     * Show delete confirmation
     */
    showDeleteAlert: function (item) {
      const title = 'Xóa cấu hình duyệt chi!';
      const text = 'Bạn có chắc muốn xóa cấu hình duyệt chi này?';
      const confirmText = 'Đồng ý';
      const optionsNotify = {
        title,
        text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: confirmText,
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        position: 'top',
      };

      Swal.fire(optionsNotify).then((result) => {
        if (result.value) {
          this.deleteItem(item);
        }
      });
    },

    /**
     * Delete item
     */
    deleteItem: async function (item) {
      try {
        const success = await ApprovalConfigService.deleteApprovalConfig(
          item.id,
        );
        if (success) {
          this.fetchData();
        }
      } catch (error) {
        console.error('Error deleting item:', error);
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Cấu hình duyệt chi', route: 'approval-configs' },
      { title: 'Danh sách cấu hình duyệt chi' },
    ]);
  },
  created() {
    this.listType = cloneDeep(APPROVAL_TYPE);
    this.listType.unshift({
      id: null,
      name: 'Loại duyệt chi',
    });
    this.fetchData();
  },
};
</script>

<style lang="scss" scoped>
.list-approval-config-page {
  .create-button {
    font-weight: 600 !important;
  }

  .add-icon {
    font-size: 1rem;
    margin-right: 0.25rem;
  }

  .dropdown-item-text {
    font-size: 12px;
    color: #3f4254;
  }

  .dropdown-item {
    padding: 0px;
  }
}
</style>
